
<p-table [columns]="resultsCols" stripedRows [value]="results">
    <ng-template #header let-columns pTemplate="frozenheader">
        <tr>
            @for ( col of columns; track col ) {
            <th pResizableColumn pSortableColumn={{col.field}}>
                {{ col.header }}
            <p-sortIcon field={{col.field}}></p-sortIcon>
            </th>
            }
        </tr>
    </ng-template>
    <ng-template #body let-rowData let-columns="columns">
        <tr>
            @for ( col of columns; track col ) {
            <td>
                {{ rowData[col.field] }}
            </td>
            }
        </tr>
    </ng-template>
</p-table>
